module.exports = __webpack_public_path__ + "img/headphones.2bc3bce5.svg";